import React, { useState } from 'react';
import cardImage from '../img/envision/casestudies/case1.JPG'; // Replace with the correct path to your image
import cardImage2 from '../img/envision/casestudies/case2.JPG'; // Replace with the correct path to your image
import cardImage3 from '../img/envision/casestudies/case3.JPG'; // Replace with the correct path to your image
import { Link } from 'react-router-dom'; // Import Link if using React Router
const TeamcenterCards = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div style={{ textAlign: 'center' }}>
            <h1 style={{ textAlign: 'center', marginBottom: '0px' }}>
            Team Center  <span style={{ color: 'rgb(16 131 158)' }}>Manufacturing</span>
            </h1>

            <div
                className="row justify-content-center"
                style={{
                    padding: '20px',
                    backgroundColor: '#fff',
                    gap: '20px',
                    width:'100%',
                }}
            >
                {/* Card 1 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{
                        padding: '15px',
                    }}
                 >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 0 ? 'rgb(7 134 159)' : '',
                            padding: '0', // Remove padding inside the card to let the text align with the card edges
                        }}
                        onMouseEnter={() => setHoveredIndex(0)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage}
                            alt="Card 1"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 0 ? 0.8 : 1,
                            }}
                        />
                        <p style={{ marginBottom: '10px', color: '#000', textAlign: 'left', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px' }}>
                            Envision Opens New State-of-the-Art Office in Sydney, Expanding its Footprint in Australia
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative', // Ensure the left and right 0 work correctly
                            left: '0',
                            right: '0',
                            marginLeft: '15px', // Add padding on the left
                            marginRight: '15px', // Add padding on the right
                            color:'#000'
                        }}>
                            With a seating capacity of over 100+ associates, the center aims to foster groundbreaking solutions and propel technological advancements.
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex', // Use flexbox for centering
                                justifyContent: 'center', // Center horizontally
                                alignItems: 'center', // Center vertically
                                flexGrow: 1, // This allows the text to take up available space and be centered
                            }}
                         >
                            <Link
                                to="/your-target-page" // Replace with the target route
                                style={{
                                    color: 'rgb(244 207 48)', // Customize text color
                                    textDecoration: 'none',
                                    fontSize: '16px', // Customize font size
                                    display: 'inline-flex', // Display inline flex for alignment
                                    alignItems: 'center', // Align items vertically
                                    cursor: 'pointer',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>




                {/* Card 2 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{
                        padding: '15px',
                    }}
                 >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 1 ? 'rgb(7 134 159)' : '',
                        }}
                        onMouseEnter={() => setHoveredIndex(1)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage2}
                            alt="Card 2"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 1 ? 0.8 : 1,
                            }}
                        />
                        <p style={{ marginBottom: '10px', color: '#000', textAlign: 'left', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px' }}>
                            Envision Opens New State-of-the-Art Office in Sydney, Expanding its Footprint in Australia
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative', // Ensure the left and right 0 work correctly
                            left: '0',
                            right: '0',
                            marginLeft: '15px', // Add padding on the left
                            marginRight: '15px', // Add padding on the right
                            color:'#000'
                        }}>
                            With a seating capacity of over 100+ associates, the center aims to foster groundbreaking solutions and propel technological advancements.
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex', // Use flexbox for centering
                                justifyContent: 'center', // Center horizontally
                                alignItems: 'center', // Center vertically
                                flexGrow: 1, // This allows the text to take up available space and be centered
                            }}
                         >
                            <Link
                                to="/your-target-page" // Replace with the target route
                                style={{
                                    color: 'rgb(244 207 48)', // Customize text color
                                    textDecoration: 'none',
                                    fontSize: '16px', // Customize font size
                                    display: 'inline-flex', // Display inline flex for alignment
                                    alignItems: 'center', // Align items vertically
                                    cursor: 'pointer',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Card 3 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{
                        padding: '15px',
                    }}
                >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 2 ? 'rgb(7 134 159)' : '',
                        }}
                        onMouseEnter={() => setHoveredIndex(2)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage3}
                            alt="Card 3"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 2 ? 0.8 : 1,
                            }}
                        />
                       <p style={{ marginBottom: '10px', color: '#000', textAlign: 'left', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px' }}>
                            Envision Opens New State-of-the-Art Office in Sydney, Expanding its Footprint in Australia
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative', // Ensure the left and right 0 work correctly
                            left: '0',
                            right: '0',
                            marginLeft: '15px', // Add padding on the left
                            marginRight: '15px', // Add padding on the right
                            color:'#000'
                        }}>
                            With a seating capacity of over 100+ associates, the center aims to foster groundbreaking solutions and propel technological advancements.
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex', // Use flexbox for centering
                                justifyContent: 'center', // Center horizontally
                                alignItems: 'center', // Center vertically
                                flexGrow: 1, // This allows the text to take up available space and be centered
                            }}
                         >
                            <Link
                                to="/your-target-page" // Replace with the target route
                                style={{
                                    color: 'rgb(244 207 48)', // Customize text color
                                    textDecoration: 'none',
                                    fontSize: '16px', // Customize font size
                                    display: 'inline-flex', // Display inline flex for alignment
                                    alignItems: 'center', // Align items vertically
                                    cursor: 'pointer',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default TeamcenterCards;
